import styles from "@shared/components/layerPopups/Emoticons.module.scss"

import React, { MouseEvent } from "react"

import { Emoji } from "@shared/components"
import { EMOTICON } from "@shared/constants"
import { useLayerPopupContext } from "@shared/contexts"
import { usePath } from "@shared/hooks"

import classNames from "classnames"

function Emoticon() {
  const { close, chat } = useLayerPopupContext()

  const isStreamerChattingPage = usePath("/streamer-chatting")

  const handleImage = (e: MouseEvent<HTMLImageElement>, name: string) => {
    e.preventDefault()
    chat.handleChat({ ...chat, emoticon: name })
  }

  return (
    <>
      <article
        className={classNames("popup", {
          [styles.minimal]: isStreamerChattingPage,
        })}
      >
        <div className="titB">
          <h1>이모티콘</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className={styles.emojiBox}>
          <span>
            {EMOTICON.map((emoticon) => (
              <Emoji
                key={emoticon}
                name={emoticon}
                onClick={(e: MouseEvent<HTMLImageElement>) =>
                  handleImage(e, emoticon)
                }
              />
            ))}
          </span>
        </div>
      </article>
    </>
  )
}

export default Emoticon
